export var PunchPhotosExceptionsReportRoutes = {
    "/punch-photos-exceptions-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.punch-photos-exceptions-report",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["punch_photo_exceptions_report"]
        },
        "views": {
            "reports-body": {
                component: "punchPhotoExceptionsReportContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Punch Photos Exceptions Report | Harri"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./punch-photo-exceptions-report.module.js");
                }
            }
        ]
    }
};